<template>
  <div>
    <app-heading
      :text="'Migration Result'"
      :heading="'main'"
    ></app-heading>

    <v-row class="mb-4">
      <v-col cols="12" sm="12" md="12" class="py-0">
        <v-row>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Complete-Provisioned"
              v-model="filterCompleted"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Complete-NotProvisioned"
              v-model="filterNotProvisioned"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="Rejected"
              v-model="filterRejected"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="3" md="2" class="py-0">
            <v-checkbox
              label="InProgress"
              v-model="filterInProgress"
              class="custom-width"
              :class="$vuetify.breakpoint.xs ? 'mt-0' : ''"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-col>


      <v-col cols="12" :md="'3'" class="pt-0 pb-1">
        <ValidationProvider
          name="Migration Reference Number"
          :rules="'required'"
          v-slot="{ errors }"
        >
          <v-text-field
            ref="migrationReferenceNumber"
            v-model="migrationReferenceNumber"
            label="Migration Reference Number"
            placeholder=" "
            outlined
            dense
            :readonly="false"
          ></v-text-field>
        </ValidationProvider>
      </v-col>
      <v-col cols="12" :md="'1'" class="pt-0 pb-1">
        <v-btn
          class="primary"
          :disabled="migrationReferenceNumber === ''"
          @click="searchResult"
        >Search</v-btn
        >
      </v-col>

      <v-col
        cols="12"
        md="6"
        class="pt-0 pb-0"
      >
        <v-btn
          class="primary"
          @click="exportRecords()"
          :disabled="items.length === 0"
        >Export Records</v-btn
        >
      </v-col>
    </v-row>

    <ag-grid-vue
      class="ag-theme-alpine"
      style="height: 60vh"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="filteredItems"
      :gridOptions="gridOptions"
      :undoRedoCellEditing="true"
      @grid-ready="onGridReady"
      :frameworkComponents="frameworkComponents"
    ></ag-grid-vue>

  </div>
</template>

<script>
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";

export default {
  name: "MigrationResult",
  components: { AgGridVue },
  data: () => ({
    defaultColDef: {
      sortable: true,
      filter: true,
      resizeable: true,
    },
    columnDefs: null,
    migrationReferenceNumber:"",
    gridOptions: {},
    items: [],
    frameworkComponents: null,
    filterCompleted: true,
    filterInProgress: true,
    filterRejected: true,
    filterNotProvisioned: true
  }),
  mounted() {
    let vm = this;
    vm.gridApi = vm.gridOptions.api;
    vm.gridColumnApi = vm.gridOptions.columnApi;
  },
  beforeMount() {
    let vm = this;
    vm.gridOptions = {};
    vm.frameworkComponents = {
    };
    vm.columnDefs = [
      {
        headerName: "CustomerReference",
        field: "customerReference",
        sortable: true,
        maxWidth: 175,
        filter: true,
      },
      {
        headerName: "NbnOrderId",
        field: "nbnOrderId",
        sortable: true,
        filter: true,
        maxWidth: 175,
      },
      {
        headerName: "OrderStatus",
        field: "nbnOrderStatus",
        sortable: true,
        filter: true,
        maxWidth: 140,
      },
      {
        headerName: "CompletedTime",
        field: "nbnOrderCompletedDatetime",
        sortable: true,
        maxWidth: 195,
        filter: true,
      },
      {
        headerName: "UsherStatus",
        field: "usherStatus",
        sortable: true,
        filter: true,
        maxWidth: 140,
      },
      {
        headerName: "TagConflict",
        field: "hasTagConfliction",
        sortable: true,
        filter: true,
        maxWidth: 140,
      },

      {
        headerName: "RadiusUsername",
        field: "radiusUsername",
        sortable: true,
        maxWidth: 170,
        filter: true,
      },
      {
        headerName: "LastAuthTime",
        field: "lastAuthDatetime",
        sortable: true,
        filter: true,
        maxWidth: 195,
      },
      {
        headerName: "ReAuthed",
        field: "reAuthed",
        sortable: true,
        filter: true,
        maxWidth: 140,
      },
    ];

    vm.defaultColDef = {
      autoHeight: true,
    };
  },
  computed: {
    filteredItems: function () {
      let vm = this;
      var result = (vm.items || []).filter(x=>
        ((vm.filterRejected && x.nbnOrderStatus === "Rejected") ||
        (vm.filterInProgress && (x.nbnOrderStatus !== "Rejected" && x.nbnOrderStatus !== "Complete")) ||
        ((vm.filterCompleted || vm.filterNotProvisioned) && x.nbnOrderStatus === "Complete")) &&
        (vm.filterCompleted && x.usherStatus === 'provisioned' ||
          vm.filterNotProvisioned && x.usherStatus === 'not-provisioned' ||
          (vm.filterRejected || vm.filterInProgress) && x.usherStatus === null
        )
      );
      return result;
    },
  },
  methods: {
    searchResult() {
      let vm = this;
      var payload = {
        "migrationBatchReference":vm.migrationReferenceNumber
      };

      vm.getMigrationResult(payload)
        .then((data) => {
          vm.items = data;
          vm.gridApi.sizeColumnsToFit();
        }).catch(() => {});

    },
    onGridReady(args) {
      let vm = this;
      vm.gridApi = args.api;
    },
    exportRecords() {
      let vm =this;
      var headers = ['CustomerReference', 'NbnOrderId', 'OrderStatus', 'CompletedTime','UsherStatus',
        'TagConflict', 'RadiusUsername', 'LastAuthTime', 'ReAuthed']
      vm.exportCSVFile(headers, vm.items, vm.gettimestamp())
    },
    covertToCSV(objArray) {
      const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
      let str = '';
      for (let i = 0; i < array.length; i++) {
        let line = '';
        for (const index in array[i]) {
          line += array[i][index];
          line += ',';
        }
        str += line + '\r\n';
      }
      return str;
    },
    gettimestamp() {
      const today = new Date();
      const date = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate();
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return 'MigrationResults ' + date + ' ' + time;
    },
    exportCSVFile(headers, items, fileTitle){
      let vm = this;
      if (headers) {
        items.unshift(headers);
      }
      const jsonObject = JSON.stringify(items);
      const csv = vm.covertToCSV(jsonObject);
      const exportedFilenmae = fileTitle + '.csv' || 'export.csv'; // eslint-disable-line
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', exportedFilenmae);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
  },
};
</script>

<style scoped></style>
